import styled from 'astroturf/react'
import { useDeviceType } from '@calendly/ui/hooks/use-device-type'
import { IconAlertCircleFilled } from '@calendly/ui/components/glyphs/IconAlertCircleFilled'
import { UiIcon } from '@calendly/ui/components/ui-icon'
import { Button } from '@calendly/ui/components/button'
import { HtmlParser } from '@calendly/html-parser'
const colorBackgroundSecondary = 'var(--colorBackgroundSecondary, var(--coreColorNeutral100))'
const fontSizeMedium = 'var(--fontSizeMedium, 0.875rem)'

import { useI18n } from 'locales'
import _ConfirmButton from "poll_votes_warning-ConfirmButton.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/select_date_time/footer/poll_votes_warning.js?styleId=ConfirmButton";
import _Container from "poll_votes_warning-Container.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/select_date_time/footer/poll_votes_warning.js?styleId=Container";
import _WarningContainer from "poll_votes_warning-WarningContainer.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/select_date_time/footer/poll_votes_warning.js?styleId=WarningContainer";
import _Message from "poll_votes_warning-Message.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/select_date_time/footer/poll_votes_warning.js?styleId=Message";
import _ButtonContainer from "poll_votes_warning-ButtonContainer.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/select_date_time/footer/poll_votes_warning.js?styleId=ButtonContainer";


const ConfirmButton = /*#__PURE__*/styled(Button, null, {
  displayName: "ConfirmButton",
  styles: _ConfirmButton,
  attrs: props => ({
    ...props,
    isPhone: useDeviceType('isPhone')
  })
})

const Container = /*#__PURE__*/styled('div', null, {
  displayName: "Container",
  styles: _Container
})

const WarningContainer = /*#__PURE__*/styled('div', null, {
  displayName: "WarningContainer",
  styles: _WarningContainer
})

const Message = /*#__PURE__*/styled('span', null, {
  displayName: "Message",
  styles: _Message
})

const ButtonContainer = /*#__PURE__*/styled('div', null, {
  displayName: "ButtonContainer",
  styles: _ButtonContainer
})

const PollVotesWarning = ({ onConfirm }) => {
  const { i18n } = useI18n()
  return (
    <Container>
      <WarningContainer>
        <UiIcon icon={IconAlertCircleFilled} size="small" />
        <Message>
          {HtmlParser(i18n.t('booking.templates.poll.single_spot_warning'))}
        </Message>
      </WarningContainer>
      <ButtonContainer>
        <ConfirmButton onClick={onConfirm}>
          {i18n.t('booking.templates.confirm')}
        </ConfirmButton>
      </ButtonContainer>
    </Container>
  )
}

export default PollVotesWarning
